<!--  -->
<template>
	<div class="page flex justb">
		<div class="left">
			<div class="title">站点介绍</div>
			<div class="flex alit justc zd">
				<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%B0%94%E8%B1%A1%E7%AB%99.png"
					alt="" />
				<div class="flexCol">
					<div class="flex alit">
						<div class="dian"></div>
						<div class="zd-title">站点名称：</div>
						<div class="zd-desc">新墩镇双堡村气象站</div>
					</div>
					<div class="flex alit" style="margin: 10px 0;">
						<div class="dian"></div>
						<div class="zd-title">设备状态：</div>
						<div class="zd-desc">在线</div>
					</div>
					<div class="flex alit">
						<div class="dian"></div>
						<div class="zd-title">运行时长：</div>
						<div class="zd-desc">263天21小时</div>
					</div>
					<div class="flex alit" style="margin: 10px 0;">
						<div class="dian"></div>
						<div class="zd-title">站点位置：</div>
						<div class="zd-desc">38.900476,100.351980</div>
					</div>
					<div class="flex">
						<div class="dian" style="margin-top: 8px;"></div>
						<div class="zd-title">站点地址：</div>
						<div class="zd-desc">甘肃省张掖市甘州区民乐县新墩镇双堡村</div>
					</div>
				</div>
			</div>
			<div class="flex justb alit" style="position: relative;">
				<div class="title" style="margin: 15px 0 20px 0">墒情诊断</div>
				<div class="db" @click="sqdbClick">对比</div>
			</div>
			<div class="" style="background: rgba(10, 145, 213, 0.1);padding: 10px;">
				<div class="flex justc sq">
					<div class="">
						<div class="flex alit">
							<el-checkbox :true-label="1" :false-label="2" v-model="oneCeck"></el-checkbox>
							<div class="dk">
								<div class="" style="margin-top: -8px;">1号地</div>
							</div>
						</div>
						<div class="flex alit justb" v-for="(item,index) in sqDataOne" style="margin-top: 5px;">
							<div class="flex alit">
								<div class="sq-color" :style="{background:sqColor[index]}"></div>
								<div class="sq-text1">{{item.title}}</div>
							</div>
							<div class="flex alit">
								<div class="sq-number" :style="{color:sqColor[index]}">{{item.number}}</div>
								<img v-if="item.upOrDown == 1"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8A%E5%8D%87%402x%20%282%29.png"
									alt="" />
								<img v-if="item.upOrDown ==2"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8B%E9%99%8D%402x%20%283%29.png"
									alt="" />
							</div>
						</div>
					</div>
					<div class="" style="margin-left: 20px;">
						<div class="flex alit">
							<el-checkbox :true-label="1" :false-label="2" v-model="twoCheck"></el-checkbox>
							<div class="dk">
								<div class="" style="margin-top: -8px;">2号地</div>
							</div>
						</div>
						<div class="flex alit justb" v-for="(item,index) in sqDataTwo" style="margin-top: 5px;">
							<div class="flex alit">
								<div class="sq-color" :style="{background:sqColor[index]}"></div>
								<div class="sq-text1">{{item.title}}</div>
							</div>
							<div class="flex alit">
								<div class="sq-number" :style="{color:sqColor[index]}">{{item.number}}</div>
								<img v-if="item.upOrDown == 1"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8A%E5%8D%87%402x%20%282%29.png"
									alt="" />
								<img v-if="item.upOrDown ==2"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8B%E9%99%8D%402x%20%283%29.png"
									alt="" />
							</div>
						</div>
					</div>


				</div>
				<div class="flex justc sq">
					<div class="">
						<div class="flex alit">
							<el-checkbox :true-label="1" :false-label="2" v-model="threeCheck"></el-checkbox>
							<div class="dk">
								<div class="" style="margin-top: -8px;">3号地</div>
							</div>
						</div>
						<div class="flex alit justb" v-for="(item,index) in sqDataThree" style="margin-top: 5px;">
							<div class="flex alit">
								<div class="sq-color" :style="{background:sqColor[index]}"></div>
								<div class="sq-text1">{{item.title}}</div>
							</div>
							<div class="flex alit">
								<div class="sq-number" :style="{color:sqColor[index]}">{{item.number}}</div>
								<img v-if="item.upOrDown == 1"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8A%E5%8D%87%402x%20%282%29.png"
									alt="" />
								<img v-if="item.upOrDown ==2"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8B%E9%99%8D%402x%20%283%29.png"
									alt="" />
							</div>
						</div>
					</div>
					<div class="" style="margin-left: 20px;">
						<div class="flex alit">
							<el-checkbox :true-label="1" :false-label="2" v-model="fourCheck"></el-checkbox>
							<div class="dk">
								<div class="" style="margin-top: -8px;">4号地</div>
							</div>
						</div>
						<div class="flex alit justb" v-for="(item,index) in sqDataFour" style="margin-top: 5px;">
							<div class="flex alit">
								<div class="sq-color" :style="{background:sqColor[index]}"></div>
								<div class="sq-text1">{{item.title}}</div>
							</div>
							<div class="flex alit">
								<div class="sq-number" :style="{color:sqColor[index]}">{{item.number}}</div>
								<img v-if="item.upOrDown == 1"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8A%E5%8D%87%402x%20%282%29.png"
									alt="" />
								<img v-if="item.upOrDown ==2"
									src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E4%B8%8B%E9%99%8D%402x%20%283%29.png"
									alt="" />
							</div>
						</div>
					</div>
				</div>
				<div class="flex alit">
					<div class="dk2">
						<div class="" style="margin-top: -8px;">标准值</div>
					</div>
				</div>
				<div class="flex justb" style="margin: 15px 0;">
					<div class="flexCol alit">
						<div class="bz-text1">上层温度 </div>
						<div class="bz-text2">25℃−28℃</div>
					</div>
					<div class="flexCol alit">
						<div class="bz-text1">上层湿度</div>
						<div class="bz-text2">70%−80%</div>
					</div>
					<div class="flexCol alit">
						<div class="bz-text1">中层温度</div>
						<div class="bz-text2">25℃−28℃</div>
					</div>
					<div class="flexCol alit">
						<div class="bz-text1">中层湿度</div>
						<div class="bz-text2">70%−80%</div>
					</div>
				</div>
				<div class="flex justb">
					<div class="flexCol alit">
						<div class="bz-text1">下层温度</div>
						<div class="bz-text2">25℃−28℃</div>
					</div>
					<div class="flexCol alit">
						<div class="bz-text1">下层湿度</div>
						<div class="bz-text2">70%−80% </div>
					</div>
					<div class="flexCol alit">
						<div class="bz-text1">土壤PH </div>
						<div class="bz-text2">6.5−7.5</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="title">预警信息</div>
			<div class="flex justc" style="margin-top: 10px;">
				<div class="zzyj-lv flexCol alit justc" @click="openCode(3)">
					<!-- <div class="yj-status" style="color: #16bc83">正常</div> -->
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E7%BB%BF%E7%A0%81.png"
						style="width: 66px; height: 66px" alt="" />
					<!-- <div class="zzyj-text">10</div> -->
				</div>
				<div class="zzyj-huang flexCol alit justc" style="margin: 0 50px" @click="openCode(2)">
					<!-- <div class="yj-status" style="color: #ffc300">告警</div> -->
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E9%BB%84%E7%A0%81.png"
						style="width: 66px; height: 66px" alt="" />
					<!-- <div class="zzyj-text">2</div> -->
				</div>
				<div class="zzyj-hong flexCol alit justc" @click="openCode(1)">
					<!-- <div class="yj-status" style="color: #fa5252">异常</div> -->
					<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/newHome/code/%E7%BA%A2%E7%A0%81.png"
						style="width: 66px; height: 66px" alt="" />
					<!-- <div class="zzyj-text">3</div> -->
				</div>
			</div>
			<div class="flex alit" style="margin-top: 10px;" v-for="item in yjData">
				<img class="yj-image"
					src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E9%A2%84%E8%AD%A6%E8%93%9D%402x.png"
					alt="" />
				<div class="yj-text">{{item.earlyInfo}} </div>
			</div>
			<div class="title" style="margin-top: 20px;">土壤肥力AI模型</div>
			<trfl style="height: 29vh;"></trfl>
			<div class="flex justb alit" style="position: relative;">
				<div class="title" style="margin: 15px 0 20px 0">边缘计算模型</div>
				<el-popover placement="left" width="400" trigger="click" popper-class="popoverclass" style="">
					甘州区域具备适宜制种玉米生长的综合环境条件。其温带大陆性气候下，夏季大气温度（10~32℃）与土壤温度（15~28℃）匹配玉米全生育期需求，既能满足植株生长热量供给，又避免极端高温胁迫；水浇地保障了土壤湿度（16~60%）的可控性，配合大气湿度（20~85%）的波动范围，可有效协调蒸腾作用与水分利用效率。土壤养分方面，氮（30~80mg/kg）、磷（10~30mg/kg）、钾（60~120mg/kg）含量处于中高水平，且pH值（5.0~7.5）适配玉米根系活性，为高产优质制种提供了良好的营养基础。综上，甘州区通过科学水肥管理可充分发挥光热资源潜力，保障制种玉米的稳产与品质优化。
					<div slot="reference" class="db" style="padding: 0 20px;">
						<div class="tex">边缘算法下发</div>
					</div>
					<!-- <div class="db" style="padding: 0 20px;" @click="sqdbClick"></div> -->
				</el-popover>

			</div>
			<div class="flex alit" style="margin-top: 20px;">
				<div class="dropchecks">
					<el-dropdown @command="dropcommand">
						<el-button class="check-button">
							玉米 <i class="el-icon-caret-bottom"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="默认">默认</el-dropdown-item>
							<el-dropdown-item command="氮">氮</el-dropdown-item>
							<el-dropdown-item command="磷">磷</el-dropdown-item>
							<el-dropdown-item command="钾">钾</el-dropdown-item>
							<el-dropdown-item command="EC">EC值</el-dropdown-item>
							<el-dropdown-item command="pH">pH</el-dropdown-item>
							<el-dropdown-item command="温度">温度</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="dropchecks">
					<el-dropdown @command="dropcommand">
						<el-button class="check-button">
							水浇地 <i class="el-icon-caret-bottom"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="默认">默认</el-dropdown-item>
							<el-dropdown-item command="氮">氮</el-dropdown-item>
							<el-dropdown-item command="磷">磷</el-dropdown-item>
							<el-dropdown-item command="钾">钾</el-dropdown-item>
							<el-dropdown-item command="EC">EC值</el-dropdown-item>
							<el-dropdown-item command="pH">pH</el-dropdown-item>
							<el-dropdown-item command="温度">温度</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="dropchecks">
					<el-dropdown @command="dropcommand">
						<el-button class="check-button">
							温带 <i class="el-icon-caret-bottom"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="默认">默认</el-dropdown-item>
							<el-dropdown-item command="氮">氮</el-dropdown-item>
							<el-dropdown-item command="磷">磷</el-dropdown-item>
							<el-dropdown-item command="钾">钾</el-dropdown-item>
							<el-dropdown-item command="EC">EC值</el-dropdown-item>
							<el-dropdown-item command="pH">pH</el-dropdown-item>
							<el-dropdown-item command="温度">温度</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<div class="dropchecks">
					<el-dropdown @command="dropcommand">
						<el-button class="check-button">
							夏季 <i class="el-icon-caret-bottom"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="默认">默认</el-dropdown-item>
							<el-dropdown-item command="氮">氮</el-dropdown-item>
							<el-dropdown-item command="磷">磷</el-dropdown-item>
							<el-dropdown-item command="钾">钾</el-dropdown-item>
							<el-dropdown-item command="EC">EC值</el-dropdown-item>
							<el-dropdown-item command="pH">pH</el-dropdown-item>
							<el-dropdown-item command="温度">温度</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			<div class="flex alit justb by">
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">大气温度</div>
					<div class="by-text2">10~32℃</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤温度</div>
					<div class="by-text2">15~28℃ </div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤湿度</div>
					<div class="by-text2">30~80mg/kg</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤PH</div>
					<div class="by-text2">5.0~7.5</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤电导率</div>
					<div class="by-text2">3.6µS/cm</div>
				</div>
			</div>
			<div class="flex alit justb by">
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">大气湿度</div>
					<div class="by-text2">20~85%</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">总辐射</div>
					<div class="by-text2">5~18℃</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤氮</div>
					<div class="by-text2">30~80mg</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤磷</div>
					<div class="by-text2">10~30mg</div>
				</div>
				<div class="byshuxian"></div>
				<div class="flexCol alit" style="width: 19%;">
					<div class="by-text1">土壤钾</div>
					<div class="by-text2">60~120mg</div>
				</div>
			</div>
		</div>
		<div class="centerbottom flex alit justc">
			<div class="flexCol" style="height: 30vh;background: rgba(10, 145, 213, 0.1);">
				<div class="title">墒情对比</div>
				<div class="flex alit" style="margin-top: 10px;margin-left: 10px;">
					<div class="sq-button" @click="openOldSq">往年同期</div>
					<!-- <div class="sq-button">1号地 VS 2号地</div> -->
				</div>
				<sqDb ref="sqDb" style="height: 25vh;"></sqDb>
			</div>
			<div class="" style="height: 30vh;margin-left: 20px;background: rgba(10, 145, 213, 0.1);">
				<div class="title">结论指导</div>
				<div class="flex alit justc" style="height: 25vh;">
					<div class="jl-pj">
						<div>优</div>
					</div>
					<div class="jl-cont">
						甘州区域具备适宜制种玉米生长的综合环境条件。其温带大陆性气候下，夏季大气温度（10~32℃）与土壤温度（15~28℃）匹配玉米全生育期需求，既能满足植株生长热量供给，又避免极端高温胁迫；水浇地保障了土壤湿度（16~60%）的可控性，配合大气湿度（20~85%）的波动范围，可有效协调蒸腾作用与水分利用效率。土壤养分方面，氮（30~80mg/kg）、磷（10~30mg/kg）、钾（60~120mg/kg）含量处于中高水平，且pH值（5.0~7.5）适配玉米根系活性，为高产优质制种提供了良好的营养基础。综上，甘州区通过科学水肥管理可充分发挥光热资源潜力，保障制种玉米的稳产与品质优化。
					</div>
				</div>
			</div>
		</div>
		<fourEmotionsMap ref="fourEmotionsMap"></fourEmotionsMap>
		<div class="mengban"></div>
	</div>
</template>

<script>
	import sqDb from './sqDb.vue'
	import fourEmotionsMap from "./fourEmotionsMap.vue";
	import trfl from './trfl.vue'
	export default {
		components: {
			sqDb,
			trfl,
			fourEmotionsMap
		},
		data() {
			return {
				yjData: [],
				fourCheck: 0,
				threeCheck: 0,
				twoCheck: 0,
				oneCeck: 0,
				sqColor: ['#8AD4FF', '#8AFFA5', '#FFF865', '#9BC74B', '#DDFAA9', '#4B4DC7', '#6B6DE2'],
				sqDataOne: [{
						"title": "土壤上层温度",
						"number": "22.8℃",
						"upOrDown": 2
					},
					{
						"title": "土壤上层湿度",
						"number": "66.4%",
						"upOrDown": 2
					},
					{
						"title": "土壤中层温度",
						"number": "23.1℃",
						"upOrDown": 2
					},
					{
						"title": "土壤中层湿度",
						"number": "73.0%",
						"upOrDown": 1
					},
					{
						"title": "土壤下层温度",
						"number": "23.3℃",
						"upOrDown": 2
					},
					{
						"title": "土壤下层湿度",
						"number": "71.9%",
						"upOrDown": 1
					},
					{
						"title": "土壤PH",
						"number": "5.1",
						"upOrDown": 2
					}
				],
				sqDataTwo: [{
						"title": "土壤上层温度",
						"number": "25.3℃",
						"upOrDown": 1
					},
					{
						"title": "土壤上层湿度",
						"number": "60.0%",
						"upOrDown": 2
					},
					{
						"title": "土壤中层温度",
						"number": "25.4℃",
						"upOrDown": 1
					},
					{
						"title": "土壤中层湿度",
						"number": "67.1%",
						"upOrDown": 2
					},
					{
						"title": "土壤下层温度",
						"number": "25.4℃",
						"upOrDown": 1
					},
					{
						"title": "土壤下层湿度",
						"number": "66.8%",
						"upOrDown": 2
					},
					{
						"title": "土壤PH",
						"number": "6.0",
						"upOrDown": 2
					}
				],
				sqDataThree: [{
						"title": "土壤上层温度",
						"number": "26.2℃",
						"upOrDown": 1
					},
					{
						"title": "土壤上层湿度",
						"number": "65.6%",
						"upOrDown": 2
					},
					{
						"title": "土壤中层温度",
						"number": "24.2℃",
						"upOrDown": 2
					},
					{
						"title": "土壤中层湿度",
						"number": "66.9%",
						"upOrDown": 2
					},
					{
						"title": "土壤下层温度",
						"number": "24.4℃",
						"upOrDown": 2
					},
					{
						"title": "土壤下层湿度",
						"number": "62.8%",
						"upOrDown": 2
					},

					{
						"title": "土壤PH",
						"number": "5.4",
						"upOrDown": 2
					}
				],
				sqDataFour: [{
						"title": "土壤上层温度",
						"number": "27.3℃",
						"upOrDown": 1
					},
					{
						"title": "土壤上层湿度",
						"number": "65.5%",
						"upOrDown": 2
					},
					{
						"title": "土壤中层温度",
						"number": "25.7℃",
						"upOrDown": 1
					},
					{
						"title": "土壤中层湿度",
						"number": "71.2%",
						"upOrDown": 1
					},
					{
						"title": "土壤下层温度",
						"number": "25.5℃",
						"upOrDown": 1
					},
					{
						"title": "土壤下层湿度",
						"number": "67.8%",
						"upOrDown": 2
					},

					{
						"title": "土壤PH",
						"number": "6.7",
						"upOrDown": 1
					}
				]
			};
		},
		// 监听属性 类似于data概念
		computed: {},
		// 监控data中的数据变化
		watch: {},
		// 方法集合
		methods: {
			openOldSq() {
				this.$refs.sqDb.init(['1号地', '2号地', '3号地', '4号地'], ["55", "48", "52", "44"], ["2.9", "3.4", "3.1", "3.8"],
					2)
			},
			sqdbClick() {
				var oneData = ["73", "68", "67", "71"]
				var twoData = ["2.1", "2.5", "2.4", "2.2"]
				var threeData = ["55", "48", "52", "44"]
				var fourData = ["2.9", "3.4", "3.1", "3.8"]

				let daName = []
				let daData1 = []
				let daData2 = []

				if (this.oneCeck == 1) {
					daName.push('1号地')
					daData1.push(oneData[0])
					daData2.push(twoData[0])
				}
				if (this.twoCheck == 1) {
					daName.push('2号地')
					daData1.push(oneData[1])
					daData2.push(twoData[1])
				}
				if (this.threeCheck == 1) {
					daName.push('3号地')
					daData1.push(oneData[2])
					daData2.push(twoData[2])
				}
				if (this.fourCheck == 1) {
					daName.push('4号地')
					daData1.push(oneData[3])
					daData2.push(twoData[3])
				}
				if (daName.length < 2) {
					this.$message({
						message: '请选择两块地块进行对比',
						type: 'warning'
					});
					return;
				}
				this.$refs.sqDb.init(daName, daData1, daData2)
			},
			getLeftBottomData(e) {
				this.$request("iot/screen/soil/listPoint").then((res) => {
					setTimeout(() => {
						this.$refs.fourEmotionsMap.setMarkers(res);
					}, 1000);
				});
				this.$request("iot/screen/weather/listCode?type=2").then((res) => {
					this.yjData = res.data
				});
			},
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getLeftBottomData("");
		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {

		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style>
	.dropchecks .el-button {
		background: #ffffff00;
		border: none !important;
	}

	.dropchecks .el-button:hover {
		background: #ffffff00;
		border: none !important;
	}

	.check-button {
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E6%8C%89%E9%92%AE%E8%83%8C%E6%99%AF%402x.png") !important;
		background-size: 103px 44px !important;
		background-repeat: no-repeat !important;
		color: #ffffff !important;
		width: 103px;
		height: 44px;
		/* border-image: linear-gradient(180deg, rgba(141, 198, 255, 0.04), rgba(159, 198, 255, 0.43)) 1 1 !important; */
	}
</style>
<style lang='scss' scoped>
	.mengban {
		position: fixed;
		z-index: 97;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		pointer-events: none;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E9%A6%96%E9%A1%B5%E8%83%8C%E6%99%AF%402x.png");
		background-size: 100% 100%;
	}

	.centerbottom {
		position: fixed;
		bottom: 20px;
		width: 100%;
		z-index: 99;

		/* 设置滚动条整体样式 */
		.jl-cont::-webkit-scrollbar {
			width: 8px;
			/* 垂直滚动条宽度 */
			height: 8px;
			/* 水平滚动条高度 */
		}

		/* 设置滚动条轨道 */
		.jl-cont::-webkit-scrollbar-track {
			background: rgba(202, 199, 199, 0.1);
			/* 轨道背景色 */
			border-radius: 4px;
			/* 圆角 */
		}

		/* 设置滚动条滑块 */
		.jl-cont::-webkit-scrollbar-thumb {
			background: #5d70db;
			/* 滑块颜色 */
			border-radius: 4px;
			/* 圆角 */
		}

		/* 设置鼠标悬停在滑块上的样式 */
		.jl-cont::-webkit-scrollbar-thumb:hover {
			background: #5166db;
			cursor: pointer;
			/* 悬停时颜色 */
		}

		.jl-cont {
			width: 268px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 10px;
			height: 100%;
			margin-top: 5px;
			overflow-y: auto;
		}

		.jl-pj {
			width: 150px;
			height: 150px;
			background-image: url('https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E6%8C%87%E5%AF%BC%E8%83%8C%E6%99%AF%402x.png');
			background-size: 100% 100%;

			div {
				font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
				font-weight: 400;
				font-size: 40px;
				color: #EDFBFF;
				line-height: 150px;
				text-align: center;
				background: linear-gradient(180deg, #FFF600 30%, #fffff3 60%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}

		}

		.sq-button {
			background-image: url('https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E6%8C%89%E9%92%AE%E8%83%8C%E6%99%AF%402x.png');
			background-size: 100% 100%;
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #FFFFFF;
			padding: 8px 15px;
			cursor: pointer;
		}
	}

	.by {
		margin-top: 30px;

		.byshuxian {
			width: 0px;
			height: 20px;
			border: 1px solid #8AD4FF;
			opacity: 0.2;
		}

		.by-text2 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #FFFFFF;
			margin-top: 5px;
		}

		.by-text1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #8AD4FF;
		}
	}

	.yj-text {
		font-family: PingFang SC, PingFang SC;
		font-size: 14px;
		color: #FFFFFF;
	}

	.yj-image {
		width: 16px;
		height: 16px;
		margin: 0 10px;
	}

	.zzyj-text {
		font-family: DINAlternateBold;
		font-size: 20px;
		color: #ffffff;
		text-align: left;
		font-style: normal;
	}

	.bz-text2 {
		font-family: DIN, DIN;
		font-weight: bold;
		font-size: 14px;
		color: #D1FFD7;
		margin-left: 10px;
	}

	.bz-text1 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}

	.sq {
		margin-bottom: 20px;

		img {
			width: 20px;
			height: 14px;
			margin-left: 5px;
		}

		.sq-number {
			font-family: DIN, DIN;
			font-weight: bold;
			font-size: 14px;
		}

		.sq-text1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #FFFFFF;
			margin-left: 5px;
		}

		.sq-color {
			width: 12px;
			height: 5px;
		}
	}

	.dk2 {
		width: 158px;
		height: 18px;
		background: linear-gradient(90deg, #3BBAA0 0%, #2A9C8E 100%);
		border-radius: 0px 0px 0px 0px;
		margin-left: 5px;
		font-family: JiangChengXieHei, JiangChengXieHei;
		font-weight: normal;
		font-size: 14px;
		color: #E6EDF8;
		text-align: center;
		line-height: -50px;
		font-style: italic;
	}

	.dk {
		width: 158px;
		height: 18px;
		background: linear-gradient(90deg, #3A61BB 0%, #29439D 100%);
		border-radius: 0px 0px 0px 0px;
		margin-left: 5px;
		font-family: JiangChengXieHei, JiangChengXieHei;
		font-weight: normal;
		font-size: 14px;
		color: #E6EDF8;
		text-align: center;
		line-height: -50px;
		font-style: italic;
	}

	.db {
		width: 100px;
		height: 44px;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E5%AF%B9%E6%AF%94%402x.png");
		background-size: 100% 100%;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		position: absolute;
		right: 0px;
		bottom: 15px;
	}

	.zd {
		padding: 20px 0;
		background: rgba(10, 145, 213, 0.1);

		img {
			width: 160px;
			height: 160px;
			margin-right: 10px;
		}

		.dian {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: #8AD4FF;
			margin-right: 5px;
		}

		.zd-title {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #8AD4FF;
		}

		.zd-desc {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #fff;
			width: 120px;
		}
	}

	.right {
		width: 382px;
		height: 85vh;
		position: fixed;
		right: 20px;
		top: 10vh;
		z-index: 999;
	}

	.left {
		width: 382px;
		height: 85vh;
		position: fixed;
		left: 20px;
		top: 10vh;
		z-index: 999;
	}

	.page {
		width: 100vw;
		height: 100vh;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%9B%9B%E6%83%85%E8%83%8C%E6%99%AF%402x.png");
		background-size: 100% 100%;
		overflow: hidden;
	}
</style>